<template>
  <div :class="$attrs?.class">
    <EngarrafadorGroup
      v-if="step === 1"
      :fabricante
      :grupo
      :categoria
      :nome="categoria.label"
      :show-grupo="categoria.informar_grupo"
      @update:fabricante="onSelectFabricante($event, categoria.name)"
      @update:grupo="onSelectGrupo($event, categoria.name)"
      @click:continue="
        onChangeStep({
          ...$event,
          solicitacaoID: solicitacaoTemplate?.id,
          categoriaID: categoria.name,
        })
      "
    />
    <template v-else-if="step === 2">
      <OButton
        size="md"
        icon="chevron_left"
        tertiary
        :label="t('back')"
        @click="onBackStep"
      />
      <div class="mt-32">
        <div class="flex ml-auto gap-8 mb-24 w-full flex-nowrap">
          <!--    <OButton label="Instruções" tertiary size="md" /> -->
          <header class="pb-24 flex items-center w-full">
            <TextIcon
              class="!text-display-2"
              icon="svguse:#icon_files"
              :text="titulo"
              icon-class="text-primary-pure hidden"
            />
          </header>
          <OSelect
            v-if="categoria.exibir_select_ano && anosDisponiveis.length > 1"
            :model-value="anoSelecionado"
            :options="anosDisponiveis"
            :label="t('parameters.year')"
            :loading="loading.anos"
            size="md"
            map-options
            class="min-w-160 bg-white"
            @update:model-value="onChangeAno"
          />
          <!-- <OButton
            :label="t('observation')"
            secondary
            size="md"
            icon="add"
            :disable="!haveAvisos"
            :loading="loading.validacoes"
            @click="onOpenAvisos"
          >
            <q-tooltip
              v-if="loading.validacoes"
              v-bind="tooltipProps"
            >
              {{ t('validatingFields') }}
            </q-tooltip>
          </OButton> -->
          <OButton
            :label="t('save')"
            :loading="loading.sending || loading.validacoes"
            primary
            size="md"
            @click="onSubmitChanges"
          >
            <q-tooltip
              v-if="loading.validacoes"
              v-bind="tooltipProps"
            >
              {{ t('validatingFields') }}
            </q-tooltip>
          </OButton>
        </div>

        <OTable
          ref="tableRef"
          :rows-per-page-options="[0]"
          :square="false"
          separator="horizontal"
          flat
          class="!w-full !h-full !bg-transparent TableTemplateUnificado"
          :loading="loading.template"
          :columns="columns"
          :rows="rows"
          :show-download-button="false"
        >
          <template #body="_props">
            <TrTemplateUnificado
              :props="_props"
              :table-structure
              :rows="rows || []"
              :validacoes
              :editing-cell-key="editingCellKey"
              @update:field="onUpdateField"
              @edit-cell="editingCellKey = $event"
              @validacoes="onSubmitValidacoes($event)"
            />
          </template>
          <template #bottom />
        </OTable>
        <div class="flex w-full justify-end mt-24">
          <OButton
            :label="t('save')"
            :loading="loading.sending || loading.validacoes"
            primary
            size="md"
            @click="onSubmitChanges"
          >
            <q-tooltip
              v-if="loading.validacoes"
              v-bind="tooltipProps"
            >
              {{ t('validatingFields') }}
            </q-tooltip>
          </OButton>
        </div>
      </div>
    </template>
  </div>
  <ModalAtencaoTemplate
    ref="modalAtencaoRef"
    @click:enviar="onSubmitAlerts"
  />
  <Transition name="fade">
    <q-page-sticky
      v-if="haveModfications"
      position="bottom"
      :offset="[0, 20]"
      class="z-[9999999999999]"
    >
      <q-badge
        :label="t('modificationsUnsaved')"
        class="bg-alert-warning-10 text-[#8a5b00] border border-alert-warning/50 px-8 py-4 text-caps-3"
      />
    </q-page-sticky>
  </Transition>
</template>

<script setup>
import { onMounted, onUnmounted, computed } from 'vue'
import { tooltipProps } from 'js/utils/GLOBAL'
import { useI18n } from 'vue-i18n'
import EngarrafadorGroup from 'components/Engarrafador/EngarrafadorGroup.vue'
import ModalAtencaoTemplate from 'components/Modal/ModalAtencaoTemplate.vue'
import OButton from 'components/Button/OButton.vue'
import OSelect from 'components/Select/OSelect.vue'
import OTable from 'components/Table/OTable.vue'
import TextIcon from 'components/Text/TextIcon.vue'
import TrTemplateUnificado from 'components/Tr/TrTemplateUnificado.vue'
import useTemplateUnificado from 'composables/useTemplateUnificado'

const props = defineProps({
  categoria: {
    type: Object,
    default: () => ({}),
  },
})

const { t } = useI18n()

const {
  onUpdateField,
  loading,
  columns,
  rows,
  validacoes,
  modalAtencaoRef,
  onOpenAvisos,
  onSubmitChanges,
  onSubmitAlerts,
  onSubmitValidacoes,
  beforeUnloadHandler,
  haveModfications,
  haveAvisos,
  fabricante,
  grupo,
  step,
  onChangeStep,
  titulo,
  editingCellKey,
  onBackStep,
  tableStructure,
  solicitacaoTemplate,
  onSelectFabricante,
  onSelectGrupo,
  anoSelecionado,
  anosDisponiveis,
  onChangeAno,
} = useTemplateUnificado()

onMounted(async () => {
  window.addEventListener('beforeunload', beforeUnloadHandler)
})

onUnmounted(() => {
  window.removeEventListener('beforeunload', beforeUnloadHandler)
})
</script>

<style lang="scss">
@import 'src/css/quasar/variables.sass';
@import 'src/css/quasar/core/typography.sass';

.TableTemplateUnificado {
  max-height: clamp(450px, 90vh, 1000px);
  overflow-y: auto;
  td:not(:last-child) {
    border-right: 1px solid rgba(var(--neutral-100), 0.1);
  }

  * {
    &::-webkit-scrollbar-thumb {
      background: rgba(var(--primary-pure), 1);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: rgb(var(--neutral-10));
      border-radius: 4px;
    }
  }

  td:first-child {
    background-color: white;
  }

  tbody {
    th:first-child,
    td:first-child {
      background-color: white;
      position: sticky;
      left: 0;
      z-index: 11;
    }
    th,
    td {
      width: 100% !important;
    }
  }

  thead {
    tr {
      min-height: 32px !important;
      th {
        position: sticky;
        padding-left: 0.875rem;
        padding-right: 0.875rem;
        width: 130px !important;

        white-space: break-spaces;
        text-align: center !important;

        top: 0;
        left: 0;
        z-index: 10;
        @include text(caps-2);
        background-color: #f3f3f4 !important;
        color: rgba(var(--neutral-100), 0.7) !important;
        font-weight: 700 !important;
        &:first-child {
          z-index: 20;
        }
      }
    }
  }
}
</style>
